import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import CustomTable from "../../components/Shared/CustomTable";
import i18next from "i18next";

export default function PurchaseVatReportTable({
  data,
  totalAmount,
  totalVat,
  grandTotal,
  vatFilter,
}) {
  const { t } = useTranslation();
  const lang = i18next.language;

  const handleData = useMemo(() => {
    if (!data) return [];

    const indexedData = data.map((item, index) => ({
      ...item,
      id: item.id || index,
      index: index + 1,
      invoice_no: item.refrence || "-",
      date: item.purchase_date || "-",
      vendor_name: lang === "ar" ? item.vendor?.name_ar : item.vendor?.name,
      vat_no: item.vendor?.vat_no || "-",
      amount: item.total_amount || 0,
      vat: item.total_vat_amount || 0,
      total: (item.total_amount || 0) + (item.total_vat_amount || 0),
    }));

    // Add total row
    return [
      ...indexedData,
      {
        id: "total_row",
        index: "",
        invoice_no: "",
        date: "",
        vendor_name: t("Total"),
        vat_no: "",
        amount: totalAmount || 0,
        vat: totalVat || 0,
        total: grandTotal || 0,
        isTotalRow: true,
      },
    ];
  }, [data, totalAmount, totalVat, grandTotal, t, lang]);

  const columns = useMemo(
    () => {
      const baseColumns = [
        {
          field: "index",
          header: t("no"),
          body: (rowData) => <div>{rowData.index}</div>,
          style: { width: "5%" },
        },
        {
          field: "invoice_no",
          header: lang === "ar" ? "رقم الفاتورة" : "Invoice No.",
          body: (rowData) => (
            <div className={`${rowData.isTotalRow ? "font-bold" : ""}`}>
              {rowData.invoice_no}
            </div>
          ),
          style: { width: "12%" },
        },
        {
          field: "date",
          header: lang === "ar" ? "التاريخ" : "Date",
          body: (rowData) => (
            <div className={`${rowData.isTotalRow ? "font-bold" : ""}`}>
              {rowData.date}
            </div>
          ),
          style: { width: "12%" },
        },
        {
          field: "vendor_name",
          header: lang === "ar" ? "اسم المورد" : "Vendor",
          body: (rowData) => (
            <div className={`${rowData.isTotalRow ? "font-bold" : ""}`}>
              {rowData.vendor_name}
            </div>
          ),
          style: { width: vatFilter === "without_vat" ? "40%" : "25%" },
        },
      ];

      if (vatFilter !== "without_vat") {
        baseColumns.push({
          field: "vat_no",
          header: lang === "ar" ? "الرقم الضريبي" : "VAT No.",
          body: (rowData) => (
            <div className={`${rowData.isTotalRow ? "font-bold" : ""}`}>
              {rowData.vat_no}
            </div>
          ),
          style: { width: "15%" },
        });
      }

      baseColumns.push({
        field: "amount",
        header: lang === "ar" ? "المبلغ (ريال)" : "Amount (SAR)",
        body: (rowData) => (
          <div className={`${rowData.isTotalRow ? "font-bold" : ""}`}>
            {rowData.amount ? rowData.amount.toFixed(2) : "0.00"}{" "}
            <span>{t("SAR")}</span>
          </div>
        ),
        style: { width: "12%" },
      });

      if (vatFilter !== "without_vat") {
        baseColumns.push({
          field: "vat",
          header: lang === "ar" ? "الضريبة (ريال)" : "VAT (SAR)",
          body: (rowData) => (
            <div className={`${rowData.isTotalRow ? "font-bold" : ""}`}>
              {rowData.vat ? rowData.vat.toFixed(2) : "0.00"}{" "}
              <span>{t("SAR")}</span>
            </div>
          ),
          style: { width: "12%" },
        });
      }

      if (vatFilter !== "without_vat") {
        baseColumns.push({
          field: "total",
          header: lang === "ar" ? "الإجمالي (ريال)" : "Total (SAR)",
          body: (rowData) => (
            <div className={`${rowData.isTotalRow ? "font-bold" : ""}`}>
              {rowData.total ? rowData.total.toFixed(2) : "0.00"}{" "}
              <span>{t("SAR")}</span>
            </div>
          ),
          style: { width: "12%" },
        });
      }

      return baseColumns;
    },
    [t, lang, vatFilter]
  );

  return (
    <div className="">
      <CustomTable
        data={handleData}
        columns={columns}
        loading={!data}
        paginator={false}
        rowClassName={(rowData) =>
          rowData.isTotalRow ? "bg-gray-100 font-semibold" : ""
        }
      />
    </div>
  );
}
